module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNi4xOSAyOC4wNCI+PHBhdGggZD0iTTEwLjc5LDE0TDAsMjUuMjIsMi43LDI4LDE2LjE5LDE0LDIuNywwLDAsMi43OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC4wMikiIHN0eWxlPSJmaWxsOiM1YjViNWIiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-right-gray.svg
// module id = 75bI
// module chunks = 0